module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "section section-white content-padded-b"
  }, [(_vm.wxapp_id && _vm.detail && _vm.detail.weapp && _vm.detail.weappTemplate) ? _c('div', [_c('div', {
    staticClass: "content-center"
  }, [(_vm.detail.head_img) ? _c('div', [_c('img', {
    staticClass: "app-img",
    attrs: {
      "src": _vm.wximageurl + _vm.detail.head_img,
      "height": "60"
    }
  })]) : _c('div', [_c('i', {
    staticClass: "iconfont icon-image fa-3x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.detail.nick_name) ? _c('div', {
    staticClass: "app-name"
  }, [_vm._v("\n          " + _vm._s(_vm.detail.nick_name) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "demo"
  }, [(_vm.detail.weapp.release_status == '1' && _vm.detail.weapp.release_ver) ? _c('div', {
    staticClass: "demo-qrcode",
    on: {
      "click": _vm.downloadWxaCode
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/code.png"),
      "alt": ""
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "info-list"
  }, [_c('li', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("模板")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-item"
  }, [_vm._v(_vm._s(_vm.detail.weappTemplate.name))]), _vm._v(" "), _c('div', [_vm._v("线上版本：" + _vm._s(_vm.detail.weapp.release_ver))])])]), _vm._v(" "), _c('li', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("版本")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-item"
  }, [_vm._v(_vm._s(_vm.detail.weappTemplate.version))]), _vm._v(" "), _c('div', [(_vm.detail.weappTemplate.template_id > _vm.detail.weapp.template_id) ? _c('div', [_vm._v("请更新到最新版本。\n               新流程：1从草稿列表中选择需要上传添加到模板列 2从模板列表中选择选中的使用模板 3先上传代\n               4.再提交审核（成功后会短信提醒指定人员）\n               5.发布（如果是小版本迭代直接发布、 如果是大版本可以选择分阶段发布按照 分阶段发布体验人员->全部人员）\n                6.如果有异常可以选择版本回退，回退注意版本描述\n\n              ")]) : _c('div', [_vm._v("当前已是最新版本 。1从草稿列表中选择需要上传添加到模板列 2从模板列表中选择选中的使用模板 3先上传代码 4再提交审核（成功后会短信提醒指定人员）。\n                5.发布（如果是小版本迭代直接发布、 如果是大版本可以选择分阶段发布按照 分阶段发布体验人员->全部人员）\n                6.如果有异常可以选择版本回退，回退注意版本描述\n              ")])])])]), _vm._v(" "), _c('li', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("上架状态")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-item"
  }, [(_vm.detail.weapp.release_status == '1') ? _c('span', [_vm._v("已上架")]) : _c('span', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("未上架")])])])]), _vm._v(" "), (_vm.detail.weapp.release_status != '1') ? _c('li', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("审核状态")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-item"
  }, [(_vm.detail.weapp.audit_status == '1') ? _c('span', [_vm._v("审核失败")]) : (_vm.detail.weapp.audit_status == '0' && _vm.detail.weapp.release_status != '1') ? _c('span', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("审核成功")]) : (_vm.detail.weapp.audit_status == '2') ? _c('span', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("审核中")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.detail.weapp.audit_status == '1' && _vm.detail.weapp.reason) ? _c('li', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("审核失败原因")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-item",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.weapp.reason)
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleBind
    }
  }, [_vm._v("更新授权")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleCGtemplateList
    }
  }, [_vm._v("代码草稿列表 ")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handletemplateList
    }
  }, [_vm._v("查看模板列表 ")]), _vm._v(" "), (_vm.detail.weappTemplate.template_id > _vm.detail.weapp.template_id) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAddWxaAction
    }
  }, [_vm._v("更新小程序")]) : (_vm.isForceUpdate || _vm.detail.weapp.audit_status === 1) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAddWxaAction
    }
  }, [_vm._v("重新提交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAddWxaAction1
    }
  }, [_vm._v("上传代码")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAddWxaAction2
    }
  }, [_vm._v("提交审核")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.tryRelease
    }
  }, [_vm._v("尝试发布")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAddWxaAction4
    }
  }, [_vm._v("分阶段发布体验成员")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAddWxaAction5
    }
  }, [_vm._v("分阶段发布全部")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAddWxaAction6
    }
  }, [_vm._v("分阶段发布详情")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAddWxaAction8
    }
  }, [_vm._v("取消分阶段发布")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.getLastAuditStatus
    }
  }, [_vm._v("查看最近一次审核状态")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.getListrevertcoderelease
    }
  }, [_vm._v("查看可回退版本 ")]), _vm._v(" "), (_vm.detail.weapp.audit_status === 2) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.handleUndocodeaudit
    }
  }, [_vm._v("审核撤回")]) : _vm._e(), _vm._v(" "), (_vm.detail.weapp.audit_status === 0) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.handleRevertcoderelease
    }
  }, [_vm._v("回退版本")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.downloadTextWxaCode
    }
  }, [_vm._v("体验二维码")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAddWxaAction7
    }
  }, [_vm._v("当前版本")])], 1)]) : _c('div', {
    staticClass: "content-center no-bind"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-padded"
  }, [_vm._v("未绑定小程序")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleBind
    }
  }, [_vm._v("授权小程序")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "小程序码",
      "visible": _vm.wxaCodeVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.wxaCodeVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.wxaCodeImage
    }
  })])]), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.showCG,
      "title": "草稿列表",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.showCG = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v("\n            选择草稿列表保存到模板库\n          ")])])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.skuLoading),
      expression: "skuLoading"
    }],
    attrs: {
      "data": _vm.CGTemlplate,
      "height": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "版本号",
      "prop": "user_version",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "描述",
      "prop": "user_desc",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源小程序",
      "prop": "source_miniprogram",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最近上传开发者",
      "prop": "developer",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最近提交时间",
      "prop": "create_time",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \n          " + _vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addToTemplLoad
          },
          on: {
            "click": function($event) {
              return _vm.addCgToTemp(scope.row.draft_id)
            }
          }
        }, [_vm._v("添加到模板库\n            ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.showTM,
      "title": "草稿列表",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.showTM = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v("\n            模板列表\n          ")])])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.skuLoading),
      expression: "skuLoading"
    }],
    attrs: {
      "data": _vm.Templatelist,
      "height": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "版本号",
      "prop": "user_version",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模板 id",
      "prop": "template_id",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "描述",
      "prop": "user_desc",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源小程序",
      "prop": "source_miniprogram",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最近上传开发者",
      "prop": "developer",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "上传时间",
      "prop": "create_time",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addToTemplLoad
          },
          on: {
            "click": function($event) {
              return _vm.useThisTemplate(scope.row.user_version, scope.row.template_id)
            }
          }
        }, [_vm._v("使用当前模板\n            ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.showRevertReleas,
      "title": "可回退小程序版本",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.showRevertReleas = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v("\n            可回退列表\n          ")])])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.skuLoading),
      expression: "skuLoading"
    }],
    attrs: {
      "data": _vm.CanRevertRelasList,
      "height": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "版本号",
      "prop": "user_version",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "描述",
      "prop": "user_desc",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小程序版本",
      "prop": "app_version",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新时间",
      "prop": "commit_time",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("datetime")(scope.row.commit_time, 'yyyy-MM-dd hh:mm:ss')) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addToTemplLoad
          },
          on: {
            "click": function($event) {
              return _vm.versionRevertcoderelease(scope.row.app_version)
            }
          }
        }, [_vm._v("回退到该版本\n            ")])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "iconfont icon-info-circle",
    staticStyle: {
      "font-size": "70px"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-25ea58cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25ea58cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/authorize/index.vue
// module id = 2548
// module chunks = 0